import React from 'react';
import { motion } from 'framer-motion';
import { Clock, RefreshCw, TrendingDown, HelpCircle } from 'lucide-react';
export function PainPoints() {
  const cards = [{
    icon: Clock,
    title: 'Perdés horas diseñando',
    desc: 'O buscando diseños que no sabés si se van a vender. El tiempo es dinero… y lo estás perdiendo.'
  }, {
    icon: RefreshCw,
    title: 'Repetís diseños quemados',
    desc: 'Te frustrás porque ves al resto vender mientras tu marca sigue igual. Necesitás diferenciarte.'
  }, {
    icon: TrendingDown,
    title: 'Le metés ganas, pero no ves resultados',
    desc: 'Sin un catálogo variado perdés volumen de ventas. La variedad es clave para escalar.'
  }, {
    icon: HelpCircle,
    title: 'Improvisás todos los días',
    desc: 'Y te abruma no saber qué vender. La incertidumbre mata cualquier negocio.'
  }];
  return <section className="py-14 md:py-16 bg-[#111827] relative" data-id="element-90">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-91">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[24px] md:text-[32px] font-black text-center mb-12 uppercase text-white" data-id="element-92">
          Lo que intentaste hasta ahora{' '}
          <span className="text-[#ef4444]" data-id="element-93">no alcanza…</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-94">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="glass-card p-6 flex flex-col items-start" data-id="element-95">
              <div className="bg-[#ef4444]/20 p-3 rounded-full mb-4" data-id="element-96">
                <card.icon className="w-6 h-6 text-[#ef4444]" data-id="element-97" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-98">
                {card.title}
              </h3>
              <p className="text-[17px] text-gray-400 leading-relaxed" data-id="element-99">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center text-center space-y-3 mb-12" data-id="element-100">
          <p className="text-lg md:text-xl font-semibold text-gray-300" data-id="element-101">
            👉 La máquina ya la tenés.
          </p>
          <p className="text-lg md:text-xl font-semibold text-gray-300" data-id="element-102">
            👉 El problema no es el esfuerzo.
          </p>
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-103">
            👉 Son los diseños que estás usando.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-104">
          <p className="text-lg text-gray-400 mb-3 uppercase tracking-widest" data-id="element-105">
            Por eso creamos el
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-[#f5a623] text-glow uppercase" data-id="element-106">
            💎 KIT VIRAL SUBLIMACIÓN & DTF 💎
          </h2>
        </motion.div>
      </div>
    </section>;
}